import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=35c6cec0&scoped=true&"
import script from "./ProjectsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTable.vue?vue&type=style&index=0&id=35c6cec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6cec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c6cec0')) {
      api.createRecord('35c6cec0', component.options)
    } else {
      api.reload('35c6cec0', component.options)
    }
    module.hot.accept("./ProjectsTable.vue?vue&type=template&id=35c6cec0&scoped=true&", function () {
      api.rerender('35c6cec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectsTable.vue"
export default component.exports